import React from 'react';
import { usePageModeContext } from 'providers/PageMode/PageMode.provider';
import { Default, SecondUpgrade, ChangePlan } from './content';
import { RootStore, withInjectedRootStore } from 'providers';
import { PurchaseMode } from 'enums';

const SubHeaderComponent = ({ rootStore }: { rootStore: RootStore }) => {
  const { purchaseMode } = usePageModeContext();
  const { isSecondUpgrade, isChangePlan } = rootStore.appStore;

  if (isSecondUpgrade) {
    return <SecondUpgrade />;
  } else if (isChangePlan || purchaseMode === PurchaseMode.CHANGE_PLAN) {
    return <ChangePlan />;
  } else {
    return <Default />;
  }
};

export const SubHeader = withInjectedRootStore(SubHeaderComponent);
